/**
 * apiFetch — drop-in replacement for fetch() that automatically prepends
 * the correct API base URL (handles production vs. local dev) and injects
 * the stored Bearer token when available.
 *
 * Usage:
 *   import { apiFetch } from '../utils/apiFetch';
 *   const res = await apiFetch('/api/bookings', { method: 'POST', body: ... });
 */
import { getApiBase } from './apiConfig';

export function apiFetch(path, options = {}) {
  // If caller already passes a full URL, use it as-is
  const isFullUrl = path.startsWith('http');

  const base = getApiBase().replace(/\/$/, ''); // e.g. "https://movd-1.onrender.com/api"
  // Strip the leading /api prefix from the path so we don't double-up
  const cleanPath = path.replace(/^\/api/, '');
  const url = isFullUrl ? path : `${base}${cleanPath}`;

  // Auto-inject Bearer token from localStorage if not already supplied
  const existingHeaders = options.headers || {};
  const hasAuth = Object.keys(existingHeaders).some(k => k.toLowerCase() === 'authorization');
  const storedToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const authHeader = (!hasAuth && storedToken) ? { Authorization: `Bearer ${storedToken}` } : {};

  return fetch(url, {
    credentials: 'include',
    ...options,
    headers: { ...authHeader, ...existingHeaders },
  });
}
